import type { ZodError } from 'zod';

export const flattenZodIssues = (error: ZodError): Record<string, string> => {
  const errors: Record<string, string> = {};
  for (const issue of error.issues) {
    const key = issue.path.join('.');
    if (!errors[key]) {
      errors[key] = issue.message;
    }
  }
  return errors;
};

// first message wins when several paths point at the same field, as flattenZodIssues does per path
export const pickFieldErrors = <TField extends string>(
  rawErrors: Record<string, string>,
  fieldOfPath: Record<string, TField>,
): Partial<Record<TField, string>> => {
  const errors: Partial<Record<TField, string>> = {};
  for (const [path, message] of Object.entries(rawErrors)) {
    const field = fieldOfPath[path];
    if (field && !errors[field]) {
      errors[field] = message;
    }
  }
  return errors;
};
